var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showExpiryNote)?_c('p',{staticClass:"expiry-notice"},[_c('i',{staticClass:"fas fa-stopwatch"}),_vm._v("\n    Expires in next 12 months\n")]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25294c9a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/office/service-products/ExpiryNotice.vue
// module id = sFS2
// module chunks = 0